import { Space } from "antd";
import Search from "antd/es/input/Search";
import { Link, useLocation } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import IconButton from "../../../components/common/IconButton";
import VendorTable from "../../../components/NP/Vendor/VendorTable";
import Subheader from "../../../components/ui/Subheader";
import { pathLink } from "../../../helpers/siteConfig";
import useDebounce from "../../../hooks/useDebounce";
import useTable from "../../../hooks/useTable";
import AdminLayout from "../../../layouts/AdminLayout";
import { useAppSelector } from "../../../store/store";
import { AddZero } from "../../../utils/number";

export default function Vendor() {
  const { usersCount, loading, allUsers } = useAppSelector(
    (state) => state.resource
  );
  const { allSupplier, supplierCount } = useAppSelector(
    (state) => state.supplier
  );
  const { keyword, handleInputChange, handleEnterValue } = useDebounce();
  const { handleSetFirstPage, ...rest } = useTable();
  const { login } = useAppSelector((state) => state.login);
  const location = useLocation();
  const path = pathLink(location.pathname, 1);

  return (
    <>
      <AdminLayout title="Vendor List" headerTitle="Vendor">
        <section className="mt-7">
          <Subheader
            title="Vendor List"
            subTitle={`Total Vendor: ${AddZero(
              keyword && !loading ? allSupplier?.length : supplierCount
            )}`}
          >
            <Space size="middle">
              <Search
                placeholder="Search by name"
                onSearch={(val) => {
                  handleEnterValue(val);
                  handleSetFirstPage(true);
                }}
                onChange={(val) => {
                  handleInputChange(val);
                  handleSetFirstPage(true);
                }}
                className="custom-search-input"
              />
              {login?.role === "edatco" && (
                <Link to={`/${path}/vendor/create`}>
                  <IconButton type="primary" nextIcon={<AddIcon />}>
                    Add new Vendor
                  </IconButton>
                </Link>
              )}

              {login?.role === "energyOps" && (
                <Link to={`/${path}/vendor/create`}>
                  <IconButton type="primary" nextIcon={<AddIcon />}>
                    Add new Vendor
                  </IconButton>
                </Link>
              )}

              {/* <IconButton
                type="primary"
                nextIcon={<AddIcon />}
                onClick={() =>
                  handleAddPoOpen({
                    type: "ADD_NEW_PO",
                  })
                }
              >
                Add New PO
              </IconButton> */}
            </Space>
          </Subheader>

          <VendorTable
            keyword={keyword}
            handleSetFirstPage={handleSetFirstPage}
            {...rest}
          />
        </section>
      </AdminLayout>
    </>
  );
}
